import React, { useEffect, useState, useRef } from 'react';
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import { useLazyGetCitiesPerCountryQuery } from '../../../../services/Api';
import LoaderSpiner from '../../../../components/loaderSpiner';
import { Pagination } from '../../../../components/Pagination';
import Dropdown from '../../../../components/Dropdown';

const DataTable = () => {
    const [currentPage, setCurrentPage] = useState(1); // Track the current page
    const [trigger, { data, isLoading, error }] = useLazyGetCitiesPerCountryQuery();
    const [dropdownActive, setDropdownActive] = useState(null); 

    const dropdownRef = useRef(null);
    // Trigger the query whenever the page changes
    useEffect(() => {
        trigger({ page: currentPage });
    }, [currentPage]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownActive(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    if (isLoading) {
        return <LoaderSpiner />;
    }

    if (error) {
        console.error("Error:", error);
        return (
          <p className="text-errorcolor">
            Error loading data. Please try again later.
          </p>
        );
    }

    const citiesData = data?.data || [];
    const totalPages = data?.data?.totalPages || 1; // Ensure totalPages is valid
    const toggleDropdown = (index) => {
        setDropdownActive((prev) => (prev === index ? null : index));
    }; 
    return (
        <div className="bg-white rounded-lg overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full table-auto border-separate border-spacing-y-4">
                    <thead>
                        <tr className="bg-buttoncolor">
                            <th className="p-3 text-left w-8 rounded-l-md">
                                <input type="checkbox" className="rounded border-normalGray" />
                            </th>
                            <th className="p-3 text-left text-black font-roboto-mono text-xs font-medium">#</th>
                            <th className="p-3 text-left text-black font-roboto-mono text-xs font-medium whitespace-nowrap">Country</th>
                            <th className="p-3 text-left text-black font-roboto-mono text-xs font-medium whitespace-nowrap">Total Number of Cities</th>
                            <th className="p-3 text-left w-20 text-black font-roboto-mono text-xs font-medium rounded-tr-md whitespace-nowrap">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {citiesData.length === 0 ? (
                            <tr>
                                <td colSpan="7" className="p-3 text-center text-normalGray font-quicksand text-lg">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            citiesData?.data?.map((row, index) => (
                                <tr
                                    key={row.id}
                                    className="bg-white rounded-md hover:bg-buttoncolor"
                                >
                                    <td className="p-3 rounded-l-md border-t border-b border-l border-solid border-[#EBE8FF]">
                                        <input type="checkbox" className="rounded border-gray-300" />
                                    </td>
                                    <td className="p-3 text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor">{index + 1}</td>
                                    <td className="p-3 text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor">{row.country}</td>
                                    <td className="p-3 text-normalGray font-quicksand text-sm font-semibold pl-16 border-t border-b border-solid border-bordercolor">{row.citiesCount} Cities</td>
                                    <td className="p-3 rounded-r-md border-t border-b border-r border-solid border-bordercolor" ref={dropdownRef}>
                                        <Dropdown
                                            // active={dropdownActive === index}
                                            onClick={() => toggleDropdown(index)}
                                            options={[
                                                { label: 'View', onClick: () => console.log('View Details') },
                                                { label: 'Edit', onClick: () => console.log('Edit clicked') },
                                                { label: 'Delete', onClick: () => console.log('Delete clicked') },
                                            ]}
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <div className="overflow-x-auto">
                <Pagination
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                /></div>

        </div>
    );
};

export default DataTable;
